import { Link } from 'react-router-dom';
import { IconAlert } from '../ui/icons';

/**
 * "Critical attention" panel. Consumes the EXISTING getDashboardAlerts payload
 * (items: { exception_id, code, package_id, severity, status }). No new API.
 */
const SEVERITY_TONE = {
  HIGH: 'border-l-rose-400 bg-rose-50/60',
  CRITICAL: 'border-l-rose-500 bg-rose-50/70',
  MEDIUM: 'border-l-amber-400 bg-amber-50/60',
  LOW: 'border-l-sky-400 bg-sky-50/50',
};

function AlertCard({ alert }) {
  const tone =
    SEVERITY_TONE[String(alert.severity || '').toUpperCase()] ||
    'border-l-slate-300 bg-eorig-surface';
  return (
    <li
      className={`rounded-xl border border-eorig-border border-l-[3px] p-3 ${tone}`}
    >
      <p className="text-sm font-semibold text-eorig-ink">
        {alert.code || 'Exception'}
      </p>
      <p className="mt-0.5 text-[12px] leading-snug text-eorig-muted">
        Package {alert.package_id}
        {alert.severity ? ` · ${alert.severity}` : ''}
        {alert.status ? ` · ${alert.status}` : ''}
      </p>
      <Link
        to={`/exceptions/${alert.exception_id}`}
        className="mt-2 inline-flex items-center text-[12px] font-semibold text-eorig-navy-600 hover:text-eorig-cyan"
      >
        Resolve →
      </Link>
    </li>
  );
}

export function CriticalAttentionPanel({ alerts, loading }) {
  return (
    <section
      className="flex flex-col rounded-2xl border border-eorig-border bg-white shadow-eorig-card"
      aria-label="Critical attention"
    >
      <div className="flex items-center justify-between border-b border-eorig-border px-4 py-3">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-rose-50 text-rose-600">
            <IconAlert className="h-4 w-4" />
          </span>
          <h2 className="text-sm font-semibold text-eorig-ink">
            Critical attention
          </h2>
        </div>
        <Link
          to="/exceptions"
          className="text-[12px] font-semibold text-eorig-navy-600 hover:text-eorig-cyan"
        >
          View all
        </Link>
      </div>
      <ul className="m-0 list-none space-y-2 p-3">
        {loading ? (
          <li className="px-1 py-6 text-center text-sm text-eorig-muted">
            Loading…
          </li>
        ) : alerts.length ? (
          alerts.map((alert) => (
            <AlertCard key={alert.exception_id} alert={alert} />
          ))
        ) : (
          <li className="rounded-xl bg-eorig-surface px-3 py-6 text-center text-sm text-eorig-muted">
            Nothing needs attention right now.
          </li>
        )}
      </ul>
    </section>
  );
}
